import React from 'react'
import { Fade } from 'components/GeneralComponents/Animations'
import LiveSearch from './LiveSearch'
import ProfileMenu from './ProfileMenu'
import LanguageSelector from './LanguageSelector'
import ProjectSelection from './ProjectSelection'
import PortfolioButton from './PortfolioButton'
import UpgradePremiumButton from './UpgradePremiumButton'
import HelpMenu from './HelpMenu'
import OrganizationAdminBtn from './OrganizationAdminBtn'

import styles from './style.module.scss'
import ModellingTopBarBtns from './ModellingTopBarBtns'

const TopBar = (props) => {
  const { isModellingPage = false } = props

  return (
    <div className={styles.topbar}>
      {isModellingPage ? (
        <ModellingTopBarBtns />
      ) : (
        <div className="mr-4">
          <Fade in>
            <HelpMenu />
          </Fade>
        </div>
      )}
      <div className="mr-auto">
        <Fade in>{false && <LiveSearch /> /* TODO */}</Fade>
      </div>
      <div className="mr-4">
        <UpgradePremiumButton />
      </div>
      <div className="mr-4">
        <OrganizationAdminBtn />
      </div>
      <div className="mr-4">
        <Fade in>
          <PortfolioButton />
        </Fade>
      </div>
      <div className="mr-4">
        <Fade in>
          <ProjectSelection />
        </Fade>
      </div>
      <div className="mr-4">
        <Fade in>
          <LanguageSelector />
        </Fade>
      </div>
      <ProfileMenu />
    </div>
  )
}

export default TopBar
